export default {
  codigo: null,
  ordenCompra: null,
  codigoPedido: null,
  fechaAlta: null,
  cliente: null,
  condicionVenta: null,
  direccionEntrega: null,
  horarioEntrega: null,
  validoHasta: null,
  moneda: null,
  vendedor: null,
  deposito: null,
  observaciones: null,
  precioTotal: null,
  impuestos: null,
  productos: [],
};
